import React, { FC, useMemo } from "react";
import { ListViewItem } from "@ingka/list-view";
import styled from "styled-components";
import { StyledListView } from "../../styles";
import Button from "@ingka/button";
import trashCan from "@ingka/ssr-icon/paths/trash-can";
import documentUpload from "@ingka/ssr-icon/paths/document-upload";
import InlineMessage from "@ingka/inline-message";
import { RequestedCreateNewApplications } from "../../../store";
import { ApplicationList, ApplicationListItemModel } from "./ApplicationList";

interface ApplicationCreatedProps {
	cancelCreateNewApplicationRequest: (appId: string) => void;
	cancelNewlyCreatedAppLoading: boolean;
	createdAppRemoving: string;
	userLoading: boolean;
	newAppsRequested?: RequestedCreateNewApplications[];
}

const ApplicationCreated: FC<ApplicationCreatedProps> = ({
	newAppsRequested,
	cancelNewlyCreatedAppLoading,
	createdAppRemoving,
	userLoading,
	cancelCreateNewApplicationRequest,
}) => {
	const items = useMemo<ApplicationListItemModel[]>(() => {
		return (newAppsRequested ?? []).map((app) => ({
			id: app.appId,
			title: app.appName,
			onDelete: () => cancelCreateNewApplicationRequest(app.appId),
			isLoading: (cancelNewlyCreatedAppLoading || userLoading) && createdAppRemoving === app.appId,
		}));
	}, [
		newAppsRequested,
		cancelCreateNewApplicationRequest,
		cancelNewlyCreatedAppLoading,
		createdAppRemoving,
		userLoading,
	]);

	return (
		<ApplicationList
			listId="application-created"
			items={items}
			emptyTitle="No new application!"
			emptyBody="Seems like you didn't create any new application yet."
		/>
	);
};

export default ApplicationCreated;
